import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";

import { NgHcaptchaComponent } from 'ng-hcaptcha';

import {AuthenticationService} from "../../services/authentication.service";

enum State {
    None,
    Ready,
    Processing,
    Success
}

@Component({
    selector: 'app-login',
    template: require('./login.component.html'),
    styles: [ require('./login.component.css') ]
})
export class LoginComponent implements OnInit {

    states = State;
    state: State = State.None;
    errorMessage: string;

    username: string;
    password: string;

    captchaSiteKey: string = '';
    captchaToken: string = '';

    @ViewChild('hcaptcha') hcaptchaComponent: NgHcaptchaComponent;

    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
        private route: ActivatedRoute,
    ) {}

    ngOnInit(): void {
        this.username = localStorage.getItem('lastUsername');
        this.state = State.Ready;

        this.captchaSiteKey = document.URL.includes('://localhost') ?
          '10000000-ffff-ffff-ffff-000000000001' : // Development Site Key
          'f1f12145-ce48-473c-900d-8e25599435e9' ; // Live Site Key
    }

    captchaResolved(captchaResponse: string) {
        this.captchaToken = captchaResponse;
    }

    onLogin(): void {
        this.errorMessage = null;
        this.state = State.Processing;
        if (this.captchaToken !== "")
        {
            this.authenticationService.authenticateUser(this.username, this.password, this.captchaToken)
                .finally(() => {
                    this.password = '';
                })
                .subscribe(
                    () => {
                        localStorage.setItem('lastUsername', this.username);
                        this.state = State.Success;

                        this.route.queryParams.subscribe(params => {
                            let returnUrl = params['returnUrl'];

                            if (returnUrl != null && returnUrl.startsWith('totes')) {
                                this.router.navigate(['/totes', returnUrl.substring('totes'.length)])
                            } else if (returnUrl == null || !this.router.navigateByUrl(returnUrl)) {
                                this.router.navigate(['/dashboard']);
                            }
                        })
                    },
                    error => {
                        this.errorMessage = error;
                        this.state = State.Ready;
                        // Reset only available in ng-hcaptcha 1.3.0 onwards
                        //this.captchaToken = '';
                        //this.hcaptchaComponent.reset();
                    }
                )
        } else {
            this.errorMessage = 'Please complete Captcha';
            this.state = State.Ready;
            // Reset only available in ng-hcaptcha 1.3.0 onwards
            //this.captchaToken = '';
            //this.hcaptchaComponent.reset();
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/components/login/login.component.ts